var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2fbba8fa03ea030d079149eb256955529bd59190"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-frontend@dune-analytics"]={id:"2fbba8fa03ea030d079149eb256955529bd59190"};
      